export * from "./insurance-submission-generator.component";